/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveFromVenueModel as DigiworkMaitreDPosDtoEmployeeRemoveFromVenueModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/remove-from-venue-model';

export interface EmployeeRemoveFromVenue$Params {
      body?: DigiworkMaitreDPosDtoEmployeeRemoveFromVenueModel
}

export function employeeRemoveFromVenue(http: HttpClient, rootUrl: string, params?: EmployeeRemoveFromVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, employeeRemoveFromVenue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

employeeRemoveFromVenue.PATH = '/api/mng/Employee/employeeremovefromvenue';
